import {
	DELETE_ITEM,
	UPDATE_ITEM,
	SET_ERRORS,
	POST_ITEM,
	LOADING_UI,
	STOP_LOADING_UI,
	GET_ITEM_RELATED_FAILURE,
	GET_ITEM_RELATED_SUCCESS,
	GET_ALL_ITEMS_FAILURE,
	GET_ALL_ITEMS_SUCCESS,
	RESET_ITEM_STATUS,
} from '../types';
import { clearErrors } from './uiActions';
import axios from 'axios';
import { toast } from 'react-toastify';
const { REACT_APP_BACKEND } = process.env;
// Post a item
export const addItem = newItem => dispatch => {
	dispatch({ type: LOADING_UI });
	axios
		.post(`${REACT_APP_BACKEND}/item`, newItem)
		.then(res => {
			dispatch({
				type: POST_ITEM,
				payload: res.data,
			});
			toast.success(res.data.message);
			dispatch(clearErrors());
		})
		.catch(err => {
			dispatch({
				type: SET_ERRORS,
				payload: err.response ? err.response.data.error : null,
			});
		});
};

export const updateItem = (itemId, updateData) => dispatch => {
	dispatch({ type: LOADING_UI });
	axios
		.put(`${REACT_APP_BACKEND}/item/${itemId}`, updateData)
		.then(res => {
			dispatch({
				type: UPDATE_ITEM,
				payload: res.data,
			});
			toast.success(res.data.message);
			dispatch(clearErrors());
		})
		.catch(err => {
			dispatch({
				type: SET_ERRORS,
				payload: err.response.data.error,
			});
		});
};

export const deleteItem = itemId => dispatch => {
    // Start loading UI
    dispatch({ type: LOADING_UI });
    axios
        .delete(`${REACT_APP_BACKEND}/item/delete/${itemId}`)
        .then(res => {
            dispatch({ type: DELETE_ITEM, payload: res.data });
            toast.success(res.data.message);
            // Stop loading UI
            dispatch({ type: STOP_LOADING_UI });
        })
        .catch(err => {
            dispatch({
                type: SET_ERRORS,
                payload: err.response ? err.response.data.error : null,
            });
            // Stop loading UI even on error
            dispatch({ type: STOP_LOADING_UI });
        });
};

export const relatedItems = category => dispatch => {
	axios
		.get(`${REACT_APP_BACKEND}/item/related/${category}`)
		.then(res => {
			dispatch({ type: GET_ITEM_RELATED_SUCCESS, payload: res.data });
		})
		.catch(err => {
			dispatch({
				type: GET_ITEM_RELATED_FAILURE,
				payload: err.response ? err.response.data.error : null,
			});
		});
};

export const getAllItems = () => dispatch => {
	axios
		.get(`${REACT_APP_BACKEND}/item/all`)
		.then(res => {
			dispatch({ type: GET_ALL_ITEMS_SUCCESS, payload: res.data.allitems || res.data.data });
		})
		.catch(err => {
			dispatch({
				type: GET_ALL_ITEMS_FAILURE,
				payload: err.response ? err.response.data.error : null,
			});
		});
};

export const getMyItems = () => dispatch => {
	axios
		.get(`${REACT_APP_BACKEND}/item`)
		.then(res => {
			dispatch({ type: GET_ALL_ITEMS_SUCCESS, payload: res.data.myitems });
		})
		.catch(err => {
			dispatch({
				type: GET_ALL_ITEMS_FAILURE,
				payload: err.response ? err.response.data.error : null,
			});
		});
};

export const resetItemStatus = () => dispatch => {
	dispatch({ type: RESET_ITEM_STATUS });
};

